import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {useTranslation} from "react-i18next";
import {leaderboardMax, sessionLeaderboard} from "business/leaderboard";
import {color, font, radius, type} from "common/tokens";
import Card from "./Card";

const TRACK_WIDTH = 64;
const MIN_FILL = 5;

const useStyles = makeStyles({
  card: {
    padding: 17,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  heading: {
    ...type.cardHeading,
    color: color.TEXT,
    margin: 0,
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 9,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 11,
    padding: '9px 11px',
    borderRadius: radius.CARD,
    background: color.SURFACE_MUTED,
  },
  name: {
    ...type.sessionTitle,
    fontWeight: font.SEMIBOLD,
    color: color.TEXT,
    margin: 0,
    flex: '1 0 0',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  track: {
    width: TRACK_WIDTH,
    height: 6,
    borderRadius: radius.PILL,
    background: color.ACCENT_TINT,
    overflow: 'hidden',
    flexShrink: 0,
  },
  fill: {
    height: '100%',
    borderRadius: radius.PILL,
    background: color.ACCENT,
  },
  count: {
    ...type.meta,
    fontWeight: font.BOLD,
    color: color.TEXT_MUTED,
    margin: 0,
    whiteSpace: 'nowrap',
  },
});

const LeaderboardCard = ({ongoingSessions, self, members}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const rows = sessionLeaderboard(ongoingSessions, self, members);
  // Nothing to compare when the viewer is the only member the app knows about.
  if (rows.length < 2) {
    return null;
  }

  const max = leaderboardMax(rows);

  return (
    <Card bordered className={classes.card}>
      <h3 className={classes.heading}>{t('sessionLeaderboard')}</h3>
      <div className={classes.rows}>
        {rows.map(row => (
          <div className={classes.row} key={row.userId}>
            <p className={classes.name}>{row.name}</p>
            <span className={classes.track}>
              <span
                className={classes.fill}
                style={{
                  display: 'block',
                  width: max > 0
                    ? Math.max(MIN_FILL, (row.completedCount / max) * TRACK_WIDTH)
                    : MIN_FILL,
                }}
              />
            </span>
            <p className={classes.count}>
              {t('sessionCount', {count: row.completedCount})}
            </p>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default LeaderboardCard;
